/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useEffect } from 'react'
import { Modal } from 'antd-mobile'
import * as _ from 'lodash'
import { BackBtn } from '@styles/button.style'
import { Title, TitleWrap } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { MatchUpFilterPage } from '@views/Matchup/MatchUpFilter'
import { isMobile } from 'react-device-detect'
import Header from '@views/PrimaryLayout/Header'
import NavBar from '@views/Navbar'
import Chat from '@views/Popup/Chat'
import { PAGE_TYPE } from '@interface/common'
import RankingPopupButton from '@views/Popup/RankingPopup/Button'

const MatchUpFilterPagePopup: React.FC = () => {
  const { globalStore, matchupStore, chattingStore, authStore, userPickStore } = useRootStore()
  const {
    visibleMatchFilterPopup,
    backButtonClosePopupId,
    setVisibleMatchFilterPopup,
  } = globalStore
  const { isChatEnabled } = chattingStore
  const { tracks, gameKey, club, producerId, detailMatchId, pageType, filterEventOnly } = matchupStore
  const onCloseMatchFilterPopup = () => {
    matchupStore.setFilterEventOnly(false)
    setVisibleMatchFilterPopup(false)

    if (matchupStore.pageType === PAGE_TYPE.USER_PICK) {
      matchupStore.setTournamentFilterList(undefined)
      userPickStore.fetchUserPickMatchesPackage().catch(console.error)
    } else if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      matchupStore.resetTournamentFilterList()
      matchupStore.resetDetailTrack()

      if (!_.isEmpty(tracks)) {
        const track = _.head(tracks)
        const { tournamentId } = track

        if (_.size(track?.matches) > 0) {
          const matchTrack = _.head(track.matches)
          matchupStore.setDetailTrack(tournamentId, matchTrack, pageType)
        }
      }
    } else {
      matchupStore.resetTournamentFilterList()

      if (!isMobile) {
        if (!_.isEmpty(tracks)) {
          const track = _.head(tracks)
          const { tournamentId } = track

          if (_.size(track.matches) > 0) {
            const matchTrack = _.head(track.matches)
            const { matchId } = matchTrack

            if (_.isEqual(detailMatchId, matchId)) {
              matchupStore.resetDetailTrack()
            }

            matchupStore.fetchMatchupDetailMarkets({
              producerId,
              tournamentId,
              gameType: gameKey,
              clubId: club?.id,
              matchId,
            }).catch(console.error)
          }
        }
      }
    }
  }

  useEffect(() => {
    if (backButtonClosePopupId !== 'visibleMatchFilterPopup') {
      return
    }
    globalStore.clearBackButtonClosePopupId()
    onCloseMatchFilterPopup()
  }, [backButtonClosePopupId])

  let titleWrapClass

  if (isMobile) {
    titleWrapClass = 'title-wrap sticky modal-tit'
  } else {
    titleWrapClass = 'title-wrap modal-tit pc-tit'
  }

  return (
    <Fragment>
      {visibleMatchFilterPopup && (
        <Modal
          popup
          maskClosable={false}
          onClose={onCloseMatchFilterPopup}
          visible={visibleMatchFilterPopup}
          animated={false}
          animationType="slide-up"
          wrapClassName={isMobile ? 'filter-page-popup' : 'filter-page-popup pc-page-popup'}
          className="full-modal"
        >
          {isMobile && <Header key="MatchupFilterPopup:Header" className="filter-page-header"/>}
          <TitleWrap className={titleWrapClass}>
            <BackBtn onClick={onCloseMatchFilterPopup}>
              <ArrowIco/>
            </BackBtn>
            <Title className="title page-tit">{filterEventOnly && '랭킹 '}리그필터</Title>
          </TitleWrap>

          <MatchUpFilterPage key="MatchupFilterPopup:MatchupFilterPage" onClose={onCloseMatchFilterPopup}/>

          {isChatEnabled
            && !globalStore.visibleMatchupDetailPopup
            && !authStore.isSpecificClubMember
            && isMobile
            && pageType !== PAGE_TYPE.USER_PICK
            && <Chat key="MatchupFilterPopup:Chat"/>}

          {/*TODO: 랭킹 현황을 볼 수 있는 팝업*/}
          <RankingPopupButton/>

          {isMobile && pageType !== PAGE_TYPE.USER_PICK && <NavBar key="MatchupFilterPopup:NavBar"/>}
        </Modal>
      )}
    </Fragment>
  )
}

export default observer(MatchUpFilterPagePopup)
